<div class="modal-wrapper">
  <div class="title-wrapper">
    <div class="icon-wrapper">
      <nb-icon icon="wysiwyg-link" pack="icomoon" class="icon"></nb-icon>
    </div>
    <h5 class="title">{{'view_translations.select_domain_for_script' | translate}}</h5>
  </div>
  <div class="other-content-container">
    <ng-select
      notFoundText="{{ 'view_translations.no_data' | translate }}"
      dropdownPosition="bottom"
      [searchable]="false"
      class="select-menu first-select payment-method-select-menu"
      [items]="dropdownData"
      bindLabel="name"
      bindValue="value"
      [(ngModel)]="selectedDomain"
      (open)="changeChevronUp()"
      (close)="changeChevronDown()"
      (change)="getSelectedDomain($event)">
    </ng-select>
  </div>
  <div class="information-custom-domain">
    <p>{{ 'need_your_domain' | t }}</p>
    <p>{{ 'need_your_domain_description' | t }}</p>
  </div>
</div>
